import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import RealisationAffairesEtrangeres from "../components/RealisationAffairesEtrangeres";

const mapStateToProps = state => ({
  lng:  state.locale.lng
});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(RealisationAffairesEtrangeres);
const withTranslationComponent = withTranslation(["realisations", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/RealisationAffairesEtrangeres.js